module.exports = __webpack_public_path__ + "6c8ea052c401cc02c7b8df13f41a4414.pdf";